import React from "react";
import { Button, Modal } from "@picklebet/ui";

import { useShareEntryHandler } from "../../hooks/useShareEntryHandler";
import { ShareEntryForm } from "./ShareEntryForm";
import { useProfile } from "@/hooks/firestore/user/useProfile";
import type { ProcessedEntry } from "@/hooks/firestore/betting/useEntries";

import * as styles from "./ShareEntryForm.module.scss";

export type ShareEntryActionProps = {
  className?: string;
  referenceId: string;
  setOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  icon?: React.ReactNode;
  entry?: [ProcessedEntry, boolean];
};

export const ShareEntryAction = ({
  referenceId,
  className,
  icon,
  isOpen,
  setOpen,
  entry,
}: ShareEntryActionProps) => {
  const { profile } = useProfile();

  const [handleSubmit, needsSecondSubmit, hasUrl, clearUrl] =
    useShareEntryHandler(referenceId, () => setOpen(false));

  return (
    <Modal.Root open={isOpen} onOpenChange={setOpen}>
      {icon && (
        <Modal.Trigger>
          <div className={className}>{icon}</div>
        </Modal.Trigger>
      )}

      <Modal.Body>
        <Modal.Header>
          <Modal.Heading>
            <Modal.Title>Share your bet</Modal.Title>
            <Modal.Subtitle>Your bet will appear as below</Modal.Subtitle>
          </Modal.Heading>
        </Modal.Header>
        <Modal.Content>
          <ShareEntryForm
            entry={entry}
            username={profile?.username!}
            onSubmit={handleSubmit}
            onFieldTouched={() => {
              if (hasUrl) {
                clearUrl();
              }
            }}
            submitButton={(isSubmitting: boolean) =>
              needsSecondSubmit ? (
                <Button
                  type="submit"
                  loading={isSubmitting}
                  variant={hasUrl ? "primary" : "info"}
                  className={styles.button}
                  size="md"
                >
                  {hasUrl ? "Copy Link" : "Get Share URL"}
                </Button>
              ) : (
                <Button
                  type="submit"
                  loading={isSubmitting}
                  className={styles.button}
                  size="md"
                >
                  Share
                </Button>
              )
            }
          />
        </Modal.Content>
      </Modal.Body>
    </Modal.Root>
  );
};
